import React, { useCallback } from 'react';

import CurrencySign from 'components/price/CurrencySign.component';
import { STYLE_DISPLAY_NONE } from 'constants/misc.const';
export const BasketItem = ({ onDecrement, onDelete, onIncrement, orderItem }) => {
  const { product, title, cost_price: costPrice, barcode, quantity } = orderItem ?? {};

  const handleDecrement = useCallback(() => onDecrement(orderItem), [onDecrement, orderItem]);
  const handleIncrement = useCallback(() => onIncrement(orderItem), [onIncrement, orderItem]);
  const handleDelete = useCallback(() => onDelete(orderItem), [onDelete, orderItem]);

  return (
    <tr key={product}>
      <td className="basket-product">
        {title}
        <div style={STYLE_DISPLAY_NONE}>{barcode}</div>
      </td>
      <td>
        <div className="quantity-count">
          <span className="decr-btn" role="button" tabIndex={0} onClick={handleDecrement} />
          {quantity}
          <span className="incr-btn" role="button" tabIndex={0} onClick={handleIncrement} />
        </div>
      </td>
      <td>
        <CurrencySign />
        {costPrice}
      </td>
      <td className="text-bold">
        <CurrencySign value={costPrice * quantity} />
      </td>
      <td>
        <span className="delete-product" role="button" tabIndex={0} onClick={handleDelete} />
      </td>
    </tr>
  );
};

export default BasketItem;
